// ----------------------------------------------------------------------------
// Component: Page Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Variables
// -------------------------------------
var SEARCH_TYPE_TAB = '.search-type__wrapper .search-type';
var ACTIVE_CLASS = 'is-active';
document.addEventListener('DOMContentLoaded', function () {
  var urlParams = new URLSearchParams(window.location.search);
  var currentType = urlParams.get('type') || 'product,page,article';
  document.querySelectorAll(SEARCH_TYPE_TAB).forEach(tab => {
    var hrefTypeMatch = tab.getAttribute('href').match(/type=([^&]+)/);
    if (hrefTypeMatch && hrefTypeMatch[1] === currentType) {
      tab.classList.add(ACTIVE_CLASS);
    }
  });
});